"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compoundDataFromCID = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const CompoundData_js_1 = require("../CompoundData.js");
async function compoundDataFromCID(cid, options = {}) {
    const { cache } = options;
    let compoundData;
    if (cache?.(cid)) {
        compoundData = cache(cid);
    }
    else {
        const dataResponse = await (0, cross_fetch_1.default)(`https://pubchem.ncbi.nlm.nih.gov/rest/pug_view/data/compound/${cid}/JSON`);
        compoundData = (await dataResponse.json()).Record;
        if (cache) {
            cache(cid, compoundData);
        }
    }
    return new CompoundData_js_1.CompoundData(compoundData);
}
exports.compoundDataFromCID = compoundDataFromCID;
//# sourceMappingURL=compoundDataFromCID.js.map